/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedLayout_viewer = {
    readonly isWordpressArticlesEnabled: boolean | null;
    readonly buyPage: {
        readonly buyPageSbUriRef: string | null;
        readonly pageType: string | null;
        readonly totalResults: number | null;
        readonly displayMaxNumberOfPages: number | null;
        readonly appliedFilters: ReadonlyArray<{
            readonly name: string | null;
            readonly values: ReadonlyArray<{
                readonly displayName: string | null;
                readonly urlLabel: string | null;
                readonly code: string | null;
            } | null> | null;
        } | null> | null;
        readonly filters: ReadonlyArray<{
            readonly " $fragmentRefs": FragmentRefs<"BuyMobileNav_filters">;
        } | null> | null;
        readonly browseContentModule: {
            readonly " $fragmentRefs": FragmentRefs<"BuySharedContentModuleRegular_browseContentModule">;
        } | null;
        readonly bottomModule: ReadonlyArray<{
            readonly " $fragmentRefs": FragmentRefs<"SharedBottomModule_bottomModule">;
        } | null> | null;
        readonly internalBuyLinks: ReadonlyArray<{
            readonly " $fragmentRefs": FragmentRefs<"BuySharedMoreWaysToBrowse_internalBuyLinks">;
        } | null> | null;
        readonly " $fragmentRefs": FragmentRefs<"BuySharedBreadcrumbs_buyPage" | "BuySharedTitle_buyPage" | "BuySharedRelatedPages_buyPage" | "BuySharedResultContainer_buyPage" | "BuySharedDescription_buyPage" | "BuySharedHead_buyPage" | "BuySharedNullSearchResults_buyPage" | "BuySharedCMSFAQ_buyPage" | "BuySharedFAQ_buyPage" | "SharedWordpressArticles_itemSearch" | "BuySharedMoreWaysToBrowse_itemSearch" | "BuyRespTopNav_buyPage" | "BuyMobileNav_buyPage">;
    } | null;
    readonly user?: {
        readonly " $fragmentRefs": FragmentRefs<"BuyRespTopNav_user" | "BuyMobileNav_user">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedMoreWaysToBrowse_viewer" | "BuySharedResultContainer_viewer" | "BuySharedNullSearchResults_viewer" | "BuyRespTopNav_viewer" | "BuyMobileNav_viewer">;
    readonly " $refType": "BuySharedLayout_viewer";
};
export type BuySharedLayout_viewer$data = BuySharedLayout_viewer;
export type BuySharedLayout_viewer$key = {
    readonly " $data"?: BuySharedLayout_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedLayout_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "localeOrigin"
    },
    {
      "kind": "RootArgument",
      "name": "page"
    },
    {
      "kind": "RootArgument",
      "name": "rootId"
    },
    {
      "kind": "RootArgument",
      "name": "uriRef"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedLayout_viewer",
  "selections": [
    {
      "alias": "isWordpressArticlesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "wordpressArticles"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"wordpressArticles\")"
    },
    {
      "alias": "buyPage",
      "args": [
        {
          "kind": "Variable",
          "name": "buyPageId",
          "variableName": "rootId"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "localeOrigin",
          "variableName": "localeOrigin"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "uriRef",
          "variableName": "uriRef"
        }
      ],
      "concreteType": "ItemSearchQueryConnection",
      "kind": "LinkedField",
      "name": "itemSearch",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "buyPageSbUriRef",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayMaxNumberOfPages",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParam",
          "kind": "LinkedField",
          "name": "appliedFilters",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchBrowseParsedParamValue",
              "kind": "LinkedField",
              "name": "values",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "urlLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseFilter",
          "kind": "LinkedField",
          "name": "filters",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BuyMobileNav_filters"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "browseContentModule",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BuySharedContentModuleRegular_browseContentModule"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BottomModule",
          "kind": "LinkedField",
          "name": "bottomModule",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SharedBottomModule_bottomModule"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternalBuyLinkType",
          "kind": "LinkedField",
          "name": "internalBuyLinks",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BuySharedMoreWaysToBrowse_internalBuyLinks"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedBreadcrumbs_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedTitle_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedRelatedPages_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedResultContainer_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedDescription_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedHead_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedNullSearchResults_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedCMSFAQ_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedFAQ_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedWordpressArticles_itemSearch"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedMoreWaysToBrowse_itemSearch"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuyRespTopNav_buyPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuyMobileNav_buyPage"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuySharedMoreWaysToBrowse_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuySharedResultContainer_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuySharedNullSearchResults_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyRespTopNav_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyMobileNav_viewer"
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BuyRespTopNav_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BuyMobileNav_user"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'f2477e47e7926cc6a49756060713cf86';
export default node;
